import ProjectBillsList from './ProjectBillsList';

export default ProjectBillsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectBillsList/index.js